<template>
  <div id="yxHome_workShops">
    <a-layout>
      <div class="workshopHeader">
        <a-row :class="handleScrollTop ? 'headerContainScroll' : 'headerContain'" ref="headerContain">
          <a-col :span="5"></a-col>
          <a-col :span="13" class="workshopHeader_msg" v-if="!handleScrollTop">
            <h2>{{courseDeatil.researchName}}</h2>
            <h4>课程内容：本课程共包括 {{courseDeatil.activityCount}} 大章，{{courseDeatil.taskCount}} 小节，{{courseDeatil.taskActCount}} 个活动。</h4>
            <div class="workshopHeader_data">
              <a-row type="flex">
                <a-col :span="8">
                  <span>课程作业数：</span>
                  <span>{{courseDeatil.workCount}}</span>
                  <!-- <a-button type="primary" @click="toSetupCourse()">去设置<a-icon type="right" /></a-button> -->
                </a-col>
                <a-col :span="8">
                  <span>课程材料数：</span>
                  <span>{{courseDeatil.materialCount}}</span>
                  <!-- <a-button type="primary" @click="toUploadCourse()">去上传<a-icon type="right" /></a-button> -->
                </a-col>
              </a-row>
            </div>
          </a-col>
          <a-col :span="13" class="workshopHeader_msg" v-if="handleScrollTop">
            <h2>{{courseDeatil.researchName}}</h2>
          </a-col>
          <a-col :span="6" style="display: flex;align-items: flex-end;justify-content: flex-end;padding: 0 40px 20px 0">
            <div class="btnGroups" v-if="!handleScrollTop">
              <!-- <a-button style="background: #49D292;color: #fff;" @click="autoBuildLesson()" v-if="appUtils.getReaserchInfo().isAuto == 'Y'">自动建课</a-button> -->
              <!-- <a-button @click="quicklogin" type="danger">预览课程</a-button> -->
            </div>
          </a-col>
        </a-row>
      </div>
      <a-layout>
        <a-layout-sider width="240" :class="handleScrollTop ? 'sidebarScroll' : 'sidebar'" :style="{ position: 'fixed', borderRight: '2px solid #E9E9E9' }" ref="sidebar">
          <a-menu :defaultSelectedKeys="[fullPath]" :selectedKeys="[fullPath]" mode="inline" :style="{ height: '100vh', borderRight: 0 }">
            <a-menu-item :key="curJti ? '/home?jti='+curJti+'&researchId='+curResearchId : '/home'">
              <router-link :to="{ path: '/home' }">
                <a-icon type="home" />
                <a-tooltip placement="left">
                  <template slot="title">
                    含视频导入、拓展阅读导入、章节名称编辑、活动类型编辑、插题与题库管理
                  </template>
                  <a-button style="background: none;border: none;">创建章节活动</a-button>
                </a-tooltip>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/courseworkSetting'">
              <router-link :to="{ path: '/courseworkSetting' }">
                <a-icon type="read" />
                <a-tooltip placement="left">
                  <template slot="title">
                    含创建作业及题目，目前支持创建主观题
                  </template>
                  <a-button style="background: none;border: none;">课程作业设置</a-button>
                </a-tooltip>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/courseDataUpload'">
              <router-link :to="{ path: '/courseDataUpload' }">
                <a-icon type="folder-open" />
                <a-tooltip placement="left">
                  <template slot="title">
                    上传资料附件
                  </template>
                  <a-button style="background: none;border: none;">课程资料包设置</a-button>
                </a-tooltip>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/quicklogin'">
              <router-link :to="{ path: '/quicklogin' }">
                <a-icon type="project" />
                <a-tooltip placement="left">
                  <a-button style="background: none;border: none;">预览课程</a-button>
                </a-tooltip>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/courseQuestionBank'">
              <router-link :to="{ path: '/courseQuestionBank' }">
                <a-icon type="calculator" />
                <a-tooltip placement="left">
                  <a-button style="background: none;border: none;">课程题库管理</a-button>
                </a-tooltip>
              </router-link>
            </a-menu-item>
            <a-menu-item :key="'/courseInfoSetting'">
              <router-link :to="{ path: '/courseInfoSetting' }">
                <a-icon type="setting" />
                <a-tooltip placement="left">
                  <a-button style="background: none;border: none;">课程信息设置</a-button>
                </a-tooltip>
              </router-link>
            </a-menu-item>
            <!-- <a-menu-item :key="'/courseInfoSetting'">
              <router-link :to="{ path: '/courseInfoSetting' }">
                <a-icon type="flag" />
                <span>课程信息设置</span>
              </router-link>
            </a-menu-item> -->
          </a-menu>
        </a-layout-sider>
        <a-layout-content :style="{ marginLeft: '240px', background: '#fff', minHeight: 'calc(100vh - 214px)' }">
          <router-view @getResearchMessageById="getResearchMessageById"></router-view>
          <div style="height: 200px;" v-if="contentBottom"></div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
// import { Icon } from 'ant-design-vue';
// const IconFont = Icon.createFromIconfontCN({
//   scriptUrl: require('../../../static/js/iconfont.js')
// });
export default {
  // components: {
  //   IconFont
  // },
  data(){
    return {
      handleScrollTop: false,
      contentBottom: false,
      fullPath: '',
      courseDeatil: {},
      curJti: '',
      curResearchId: ''
    };
  },
  created () {
    if (this.$route.query.jti){
      this.curJti = this.$route.query.jti;
      this.curGroupId = this.$route.query.groupId;
      this.curResearchId = this.$route.query.researchId;
    }
    this.getResearchMessageById();
    this.fullPath = this.$route.fullPath;
  },
  mounted () {
    var that = this;
    window.onscroll = function(){
      that.handleScroll();
    };
  },
  updated () {
    this.fullPath = this.$route.fullPath;
    if (this.curJti && this.fullPath.indexOf('jti') == -1){
      this.curJti = '';
    }
  },
  methods: {
    quicklogin(){
      this.$router.push({path: '/quicklogin'});
    },
    toSetupCourse(){
      this.$router.push({path: '/courseworkSetting'});
    },
    toUploadCourse(){
      this.$router.push({path: '/courseDataUpload'});
    },
    autoBuildLesson(){
      let data = {
        'userId': this.appUtils.getUserId(),
        'researchId': this.appUtils.getResearchId(),
        'researchName': this.appUtils.getReaserchInfo().researchName
      }
      let url = this.apis.courseInfoSetting.postAutoBuildLesson;
      this.http.post(url, data)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('自动建课成功');
        }
      }).catch((err)=> {
        this.$message.error(err.message);
      });
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        this.handleScrollTop = true;
        this.contentBottom = true;
      } else {
        this.handleScrollTop = false;
        this.contentBottom = false;
      }
    },
    getResearchMessageById(){
      let url = this.apis.courseInfoSetting.getResearchMessageById + this.appUtils.getResearchId();
      this.http.get(url)
      .then(({data})=>{
        this.courseDeatil = data;
        let obj ={
          researchName: data.researchName,
          isAuto: data.isAuto
        };
        localStorage.setItem(this.constStatic.RESEARCH_INFO, JSON.stringify(obj));
      }).catch((err)=> {
        console.log(err);
      });
    }
  }
};
</script>

<style lang="less">
#yxHome_workShops {
  &>*{
    box-sizing: border-box;
  }
  .ant-layout-header{
    background: #fff;
  }
  .ant-layout-sider {
    background: #fff;
  }
  .sidebar {
    max-height: calc(100vh - 215px);
  }
  .sidebarScroll {
    max-height: calc(100vh - 114px);
  }
  .ant-menu{
    text-align: left;
  }
  .workshopHeader{
    background: url('../../static/images/yxHome_bg.png') no-repeat;
    background-size: 100% 100%;
    min-height: 50px;
    .headerContain{
      height: 150px;
      padding-top: 30px;
    }
    .headerContainScroll{
      width: 100%;
      height: 50px;
      position: fixed;
      top: 64px;
      background: #fff;
      padding-top: 10px;
      z-index: 20;
      border-bottom:1px solid rgba(232,232,232,1);
      box-shadow:0px 4px 12px rgba(238,238,238,1);
    }
    .ant-col{
      height: 100%;
    }
    .workshopHeader_msg{
      text-align: left;
      h2{
        height: 30px;
        line-height: 30px;
        font-size: 20px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // span{
        //   display: inline-block;
        //   width:52px;
        //   height:22px;
        //   line-height: 22px;
        //   background:rgba(246,255,237,1);
        //   border:1px solid rgba(183,235,143,1);
        //   border-radius:4px;
        //   font-size: 12px;
        //   color:rgba(82,196,26,1);
        //   text-align: center;
        //   margin-left: 10px;
        // }
      }
      h4{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #666;
      }
      .workshopHeader_data{
        height: 20px;
        line-height: 20px;
        min-width: 400px;
        font-size: 14px;
        color: #666;
        .ant-col{
          min-width: 200px;
          height: 32px;
          line-height: 32px;
          span:nth-child(2){
            color: #1890FF;
          }
          .ant-btn{
            margin-left: 10px;
          }
        }
      }
    }
    .btnGroups{
      .ant-btn{
        margin-left: 17px;
      }
    }
  }
}
</style>
